import { DatePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ControlsOf, FormGroup } from '@ngneat/reactive-forms';
import { Realisation, RealisationHourtype } from 'src/app/classes/realisation';
import type { FgRealisation } from 'src/app/components/hour-control/hour-control.types';
import { DoesNotMatchDriverPipe } from 'src/app/pages/check-hours/does-not-match-driver.pipe';
import { IsTraveltimePipe } from 'src/app/pages/check-hours/is-traveltime.pipe';
import { HourtypePipe } from 'src/app/pipes/hourtype.pipe';

@Component({
    selector: 'app-realisation-row-time-project',
    imports: [DatePipe, DoesNotMatchDriverPipe, HourtypePipe, IsTraveltimePipe, MatTooltipModule],
    templateUrl: './realisation-row-time-project.component.html',
    styleUrl: './realisation-row-time-project.component.scss',
    host: {
        class: 'd-flex align-items-center',
    },
})
export class RealisationRowTimeProjectComponent {
    readonly driverRealisations = input.required<Realisation[]>();
    readonly form = input.required<FormGroup<ControlsOf<FgRealisation>>>();
    readonly notEditable = input(false);
    readonly projectId = input<string>();
    readonly projectName = input<string>();
    readonly realisation = input.required<Realisation>();

    readonly projectEdit = output<void>();
    readonly timeEdit = output<{ field: 'begindate' | 'enddate'; addToCurrentTime: number }>();

    readonly RealisationHourtype = RealisationHourtype;

    editProject(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        this.projectEdit.emit();
    }

    editTime(event: Event, field: 'begindate' | 'enddate', addToCurrentTime: number): void {
        event.preventDefault();
        event.stopPropagation();
        this.timeEdit.emit({ field, addToCurrentTime });
    }
}
